export default "__VITE_ASSET__Du0oF25Q__"